<main class="whats-new-page">
  <div class="top-row">
    <button type="button" class="back-btn" [attr.aria-label]="'profile.backAria' | translate" (click)="goBack()">
      <sz-icon name="arrow-back" [size]="20" />
    </button>
    <sz-brand-block [compact]="true" />
  </div>

  <div class="wn-head">
    <h1 class="wn-head__title">{{ 'whatsNew.pageTitle' | translate }}</h1>
  </div>

  @if (!loading()) {
    @if (versions().length === 0) {
      <p class="wn-empty">{{ 'whatsNew.empty' | translate }}</p>
    } @else {
      <ul class="wn-list">
        @for (v of versions(); track v.version) {
          <li class="wn-item" [class.is-open]="isExpanded(v.version)">
            <button
              type="button"
              class="wn-item__head"
              [attr.aria-expanded]="isExpanded(v.version)"
              (click)="toggle(v.version)">
              <span class="wn-item__ver">{{ v.version }}</span>
              @if (v.date) {
                <span class="wn-item__date">{{ v.date }}</span>
              }
              <span class="wn-item__chev"><sz-icon name="chevron-right" [size]="16" /></span>
            </button>

            @if (isExpanded(v.version)) {
              <ul class="wn-changes">
                @for (c of v.changes; track $index) {
                  <li class="wn-change">
                    <span class="wn-change__icon"><sz-icon [name]="iconFor(c.icon)" [size]="18" /></span>
                    <span class="wn-change__text">{{ c.text }}</span>
                  </li>
                }
              </ul>
            }
          </li>
        }
      </ul>
    }
  }
</main>
